import React from 'react'
import { IoIosArrowForward } from "react-icons/io";


function DLTBulkUploader() {
    return (
        <>
            <div className='sm:pt-[70px] pt-[100px] dark:bg-[#121519]  min-h-screen px-4'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 '>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>DLT Bulk Upload</h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  <span>Home</span> <IoIosArrowForward />
                        <span>DLT Bulk Upload</span> </div>
                </div>
                <div className='border-b-[1px] border-[#cfcdcd] pb-10 pt-2 w-[100%]'>

                    <div className='flex w-[100%] gap-4 items-center'>
                        <div className='border-[1px] border-[#cfcdcd] max-w-[500px] p-2 rounded-md flex items-center gap-2 w-[100%]'>
                            <input type="file"
                                placeholder='Enter userName'
                                className='w-[100%] outline-none text-[#cfcdcd] text-[12px] dark:text-[#fff] dark:bg-[#121519]'
                            />

                        </div>
                        <button className='border-[1px] border-[#3f7fca] text-[#3f7fca] hover:bg-[#3f7fca] hover:text-[#fff] flex items-center text-[12px] p-2 font-semibold rounded-lg gap-1 '>
                            Load</button>
                    </div>
                    <div className='flex justify-between items-center w-[100%] max-w-[500px]' >
                        <span className='text-[12px] text-red-600'>{`(Note: Support's only .xls or .xlsx Files)`}</span>
                        <span className='text-[12px] text-red-600'>Sample File</span>
                    </div>
                </div>

            </div>
        </>
    )
}

export default DLTBulkUploader
